import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import ListBulletSvg from '@/assets/ListBullet.svg';

const ListBullet = ({ size, variant, className }: IconProps) => (
  <img
    src={ListBulletSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default ListBullet;
